import type { DpiaRecommendation, DpiaRequestContext, DpiaRequestDecision, DpiaScreeningCriterionCode } from './dpiaRequests.types';

export const calculateDpiaRecommendation = (
  selectedCriteria: DpiaScreeningCriterionCode[],
  alwaysDpiaRuleTriggered: boolean,
): DpiaRecommendation => {
  if (alwaysDpiaRuleTriggered) {
    return 'dpia_strongly_recommended';
  }

  const count = selectedCriteria.length;

  if (count === 0) {
    return 'normally_not_recommended';
  }

  if (count === 1) {
    return 'further_assessment_recommended';
  }

  return 'dpia_recommended';
};

export const doesDecisionDeviateFromRecommendation = (decision: DpiaRequestDecision, recommendation: DpiaRecommendation): boolean => {
  if (decision === 'dpia_required' && recommendation === 'normally_not_recommended') {
    return true;
  }

  if (decision === 'dpia_not_required' && recommendation === 'dpia_recommended') {
    return true;
  }

  if (decision === 'dpia_not_required' && recommendation === 'dpia_strongly_recommended') {
    return true;
  }

  return false;
};

export const buildProposedDpiaTitle = (context: DpiaRequestContext): string =>
  `DPIA – ${context.assetName} – ${context.processingActivityName}`;

export const pickCurrentDpiaIdFromHistory = (
  items: Array<{ id: number; kind: string; status: string; isCurrent?: boolean }>,
): number | null => {
  const dpias = items.filter(item => item.kind === 'dpia');
  const current = dpias.find(item => item.isCurrent);
  if (current) {
    return current.id;
  }

  const inProgress = dpias.find(item => ['in_progress', 'ready_for_review', 'clarification_requested'].includes(item.status));
  return inProgress?.id ?? dpias[0]?.id ?? null;
};
